import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import SplashStacy from "./components/SplashStacy";
import { useState } from "react";

export default function App() {
  const [showSplash, setShowSplash] = useState(true);
  const [splashLeaving, setSplashLeaving] = useState(false);

  return (
    <>
      <div
        className={`min-h-screen bg-[#F2F1DE] transition-opacity duration-1000 ease-[cubic-bezier(0.22,1,0.36,1)] ${
          splashLeaving || !showSplash ? "opacity-100" : "opacity-0"
        }`}
      >
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
        </Routes>
      </div>

      {showSplash && (
        <SplashStacy
          isLeaving={splashLeaving}
          onStartExit={() => setSplashLeaving(true)}
          onComplete={() => setShowSplash(false)}
        />
      )}
    </>
  );
}